(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.deleteError = null;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            vm.deleteError = null;
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                },
                function (error) {
                    vm.deleteError = (error.headers && error.headers('X-wamasysApp-detail')) || 'Suppression impossible.';
                });
        }
    }
})();
